(function () {
  "use strict";

  var roots = document.querySelectorAll("[data-psychic-compass]");
  if (!roots.length) return;

  var PSYCHIC_PRODUCT_REGISTRY = { indepth: "53705415098641" };
  var PSYCHIC_PRODUCT_SKU = "READING-PREMIUM";

  Array.prototype.forEach.call(roots, function (root) {
    var apiBase = String(root.getAttribute("data-api-base") || "").replace(/\/$/, "");
    if (!apiBase) return;
    function normalizeLocale(value) {
      var raw = String(value || "en").trim().replace(/_/g, "-").toLowerCase();
      var registry = window.DeckauraLocaleRegistry && window.DeckauraLocaleRegistry.locales;
      if (registry) {
        var canonical = Object.keys(registry).filter(function (key) {
          return (registry[key].aliases || []).indexOf(raw) >= 0;
        })[0];
        if (canonical) return canonical;
      }
      if (raw === "pt-pt") return "pt-PT";
      if (raw === "pt" || raw.indexOf("pt-br") === 0) return "pt-BR";
      if (raw.indexOf("de") === 0) return "de";
      if (raw.indexOf("es") === 0) return "es";
      if (raw.indexOf("tr") === 0) return "tr";
      return "en";
    }
    var locale = normalizeLocale(root.getAttribute("data-pc-locale") || document.documentElement.lang || "en");
    var storageKey = "deckaura_psychic_compass_v1_" + locale;
    var visitorKey = "deckaura_psychic_visitor_v1";
    var analyticsSessionKey = "deckaura_psychic_analytics_session_v1_" + locale;
    var translations = {
      en: {
        assurance: "Reading assurances", trust1: "1 free reading / 24h", trust2: "No signup", trust3: "No credit card", trust4: "Private", trust5: "18+",
        stepQuestion: "1 Your question", questionLabel: "What would you like clarity on today?", questionPlaceholder: "Type the question that is already on your mind…", questionHelp: "One honest question is enough. You will not need to type it again.", topicAria: "Optional question topic", love: "Love & Relationships", career: "Career & Money", decision: "A Decision", timing: "Timing & What's Next", life_path: "Life Path & Purpose", signs: "Dreams, Signs & Numbers", start: "Start My Free Reading →", disclosure: "A symbolic reading shaped around your question with Deckaura’s tarot, rune, astrology and numerology methods. For reflection, not live human advice or a guaranteed prediction.",
        stepContext: "2 One useful detail", shortDetail: "Add one short detail", birth: "Birth date (optional — adds a Life Path layer)", chooseCards: "Choose My Cards →", editQuestion: "← Edit my question",
        stepCards: "3 The Intuitive Compass", cardsTitle: "Choose the two cards that pull you in", cardsHelp: "First: The Energy Now. Second: What Shifts It.", cardsAria: "Choose exactly two cards", card: "Card", firstCard: "Choose your first card.", reveal: "Reveal My Free Reading →", changeDetail: "← Change the detail",
        loadingTitle: "Connecting your question and symbols", loadingHelp: "No email is needed. Keep this tab open for your free signal.", loading1: "Reading the energy now…", loading2: "Connecting what shifts it…", loading3: "Adding your supporting signal…", loading4: "Checking the reading for consistency…",
        used: "Your reading used", direct: "Your Direct Signal", why: "Why It Leans This Way", hidden: "The Hidden Influence", control: "What Is Within Your Control", uncertain: "What Remains Uncertain",
        followupStep: "✓ One free follow-up", followupLabel: "What would you like to understand more clearly?", followupButton: "Ask My Follow-Up", followupKicker: "Your Follow-Up",
        offerKicker: "Continue with the exact same question and symbols", offerDefault: "Go deeper into the deciding condition.", complete: "Complete personalized reading", packageFallback: "In-Depth", packageDetail: "1,250–1,500 words · alternative paths · risks · conditional timing · 30-day plan · one written follow-up", checkingPrice: "Price is being checked…", checkoutFallback: "Get My In-Depth Reading", delivery1: "Usually delivered by email in 20–30 minutes; allow up to 90", delivery2: "Your exact question and cards stay together through checkout", delivery3: "100% digital · nothing ships",
        privacySummary: "How is my question handled?", privacyBody: "Your question is securely sent to Deckaura's reading service to create the result. The free session is stored for up to 30 days so you can continue to checkout without retyping your question. It is not added to a marketing list. Optional birth data is used only for the symbolic layer you request.", deleteReading: "Delete this reading",
        minQuestion: "Write one clear question using at least 8 characters.", understanding: "Understanding your question…", restrictedContext: "No additional context collected for a restricted question.", understood: "Question understood. One useful detail is next.", contextFallback: "Add one useful detail.", contextRequired: "Add one short detail, or add your optional birth date.", optionRequired: "Choose the option that best matches your situation.", chooseTwo: "Choose two cards for The Intuitive Compass.", energyNow: "Energy Now", shiftsIt: "What Shifts It", secondCard: "Now choose What Shifts It.", cardsReady: "Your two cards are ready.", exactlyTwo: "Choose exactly two cards.", resultReady: "Your free signal is ready.", supporting: "Supporting signal", followupRequired: "Write one short follow-up question.", followupBusy: "Connecting this to your reading…", followupReady: "Your free follow-up is ready.", verifyPackage: "Verifying your package…", openCheckout: "Opening secure checkout…", restored: "Your saved reading has been restored.", deleteConfirm: "Delete this reading and its saved question? This cannot be undone.", deleting: "Deleting…",
        errLimit: "Your free reading renews every 24 hours. Return to this page when your next reading is available.", errProduct: "This package is temporarily paused while we verify its Shopify price. No item was added to your cart.", errPaid: "A paid prediction is not offered for high-stakes questions. Please use the grounded next step in your free answer.", errProgress: "Your reading is still being prepared. Wait a moment, then try once more.", errDefault: "We could not complete that step. Your question is saved in this browser, so please try again.", upright: "upright", reversed: "reversed"
      },
      de: {
        assurance: "Hinweise zur Deutung", trust1: "1 kostenlose Deutung pro 24 Std.", trust2: "Ohne Anmeldung", trust3: "Keine Kreditkarte", trust4: "Privat", trust5: "Ab 18",
        stepQuestion: "1 Deine Frage", questionLabel: "Wozu wünschst du dir heute Klarheit?", questionPlaceholder: "Schreibe die Frage auf, die dich bereits beschäftigt…", questionHelp: "Eine ehrliche Frage genügt. Du musst sie später nicht erneut eingeben.", topicAria: "Optionales Thema der Frage", love: "Liebe & Beziehungen", career: "Beruf & Finanzen", decision: "Eine Entscheidung", timing: "Zeitpunkt & nächste Schritte", life_path: "Lebensweg & Bestimmung", signs: "Träume, Zeichen & Zahlen", start: "Kostenlose Deutung starten →", disclosure: "Eine symbolische Deutung, abgestimmt auf deine Frage und Deckauras Tarot-, Runen-, Astrologie- und Numerologiemethoden. Zur Reflexion, nicht als menschliche Live-Beratung oder garantierte Vorhersage.",
        stepContext: "2 Ein hilfreiches Detail", shortDetail: "Ein kurzes Detail ergänzen", birth: "Geburtsdatum (optional — ergänzt eine Lebensweg-Ebene)", chooseCards: "Meine Karten wählen →", editQuestion: "← Frage bearbeiten",
        stepCards: "3 Der Intuitive Kompass", cardsTitle: "Wähle die zwei Karten, die dich anziehen", cardsHelp: "Zuerst: Die aktuelle Energie. Danach: Was sie verändert.", cardsAria: "Genau zwei Karten wählen", card: "Karte", firstCard: "Wähle deine erste Karte.", reveal: "Kostenlose Deutung anzeigen →", changeDetail: "← Detail ändern",
        loadingTitle: "Deine Frage wird mit den Symbolen verbunden", loadingHelp: "Keine E-Mail erforderlich. Lass diesen Tab für dein kostenloses Signal geöffnet.", loading1: "Die aktuelle Energie wird gedeutet…", loading2: "Die Veränderung wird eingeordnet…", loading3: "Das ergänzende Symbol wird hinzugefügt…", loading4: "Die Deutung wird auf Stimmigkeit geprüft…",
        used: "Für deine Deutung verwendet", direct: "Dein direktes Signal", why: "Warum es in diese Richtung weist", hidden: "Der verborgene Einfluss", control: "Was du beeinflussen kannst", uncertain: "Was offenbleibt",
        followupStep: "✓ Eine kostenlose Rückfrage", followupLabel: "Was möchtest du noch genauer verstehen?", followupButton: "Rückfrage stellen", followupKicker: "Deine Rückfrage",
        offerKicker: "Mit derselben Frage und denselben Symbolen fortfahren", offerDefault: "Vertiefe den entscheidenden Zusammenhang.", complete: "Vollständige persönliche Deutung", packageFallback: "Ausführlich", packageDetail: "1.250–1.500 Wörter · alternative Wege · Risiken · bedingter Zeitrahmen · 30-Tage-Plan · eine schriftliche Rückfrage", checkingPrice: "Preis wird geprüft…", checkoutFallback: "Ausführliche Deutung erhalten", delivery1: "Meist in 20–30 Minuten per E-Mail; bitte bis zu 90 Minuten einplanen", delivery2: "Deine genaue Frage und Karten bleiben im Checkout zusammen", delivery3: "100 % digital · kein Versand",
        privacySummary: "Wie wird meine Frage verarbeitet?", privacyBody: "Deine Frage wird sicher an Deckauras Deutungsdienst übermittelt, um das Ergebnis zu erstellen. Die kostenlose Sitzung wird bis zu 30 Tage gespeichert, damit du ohne erneute Eingabe zum Checkout weitergehen kannst. Sie wird keiner Marketingliste hinzugefügt. Ein optionales Geburtsdatum wird nur für die gewünschte symbolische Ebene verwendet.", deleteReading: "Diese Deutung löschen",
        minQuestion: "Formuliere eine klare Frage mit mindestens 8 Zeichen.", understanding: "Deine Frage wird eingeordnet…", restrictedContext: "Bei einer sensiblen Frage werden keine zusätzlichen Angaben erfasst.", understood: "Frage verstanden. Als Nächstes hilft ein Detail.", contextFallback: "Ergänze ein hilfreiches Detail.", contextRequired: "Ergänze ein kurzes Detail oder optional dein Geburtsdatum.", optionRequired: "Wähle die Option, die am besten zu deiner Situation passt.", chooseTwo: "Wähle zwei Karten für den Intuitiven Kompass.", energyNow: "Aktuelle Energie", shiftsIt: "Was sie verändert", secondCard: "Wähle jetzt, was sie verändert.", cardsReady: "Deine zwei Karten sind bereit.", exactlyTwo: "Wähle genau zwei Karten.", resultReady: "Dein kostenloses Signal ist bereit.", supporting: "Ergänzendes Symbol", followupRequired: "Formuliere eine kurze Rückfrage.", followupBusy: "Die Rückfrage wird mit deiner Deutung verbunden…", followupReady: "Deine kostenlose Rückfrage ist bereit.", verifyPackage: "Paket und Preis werden geprüft…", openCheckout: "Sicherer Checkout wird geöffnet…", restored: "Deine gespeicherte Deutung wurde wiederhergestellt.", deleteConfirm: "Diese Deutung und die gespeicherte Frage endgültig löschen?", deleting: "Wird gelöscht…",
        errLimit: "Deine kostenlose Deutung wird alle 24 Stunden erneuert. Kehre zurück, sobald die nächste Deutung verfügbar ist.", errProduct: "Dieses Paket ist vorübergehend pausiert, während wir den Shopify-Preis prüfen. Deinem Warenkorb wurde nichts hinzugefügt.", errPaid: "Für sensible Fragen wird keine kostenpflichtige Vorhersage angeboten. Nutze bitte den bodenständigen nächsten Schritt aus deiner kostenlosen Antwort.", errProgress: "Deine Deutung wird noch erstellt. Warte einen Moment und versuche es erneut.", errDefault: "Dieser Schritt konnte nicht abgeschlossen werden. Deine Frage ist in diesem Browser gespeichert; versuche es bitte erneut.", upright: "aufrecht", reversed: "umgekehrt"
      },
      es: {
        assurance: "Garantías de la lectura", trust1: "1 lectura gratis cada 24 h", trust2: "Sin registro", trust3: "Sin tarjeta", trust4: "Privada", trust5: "Mayores de 18",
        stepQuestion: "1 Tu pregunta", questionLabel: "¿Sobre qué te gustaría tener claridad hoy?", questionPlaceholder: "Escribe la pregunta que ya tienes en mente…", questionHelp: "Una pregunta sincera es suficiente. No tendrás que escribirla de nuevo.", topicAria: "Tema opcional de la pregunta", love: "Amor y relaciones", career: "Trabajo y dinero", decision: "Una decisión", timing: "Momento y próximos pasos", life_path: "Camino de vida y propósito", signs: "Sueños, señales y números", start: "Empezar mi lectura gratis →", disclosure: "Una lectura simbólica adaptada a tu pregunta con los métodos de tarot, runas, astrología y numerología de Deckaura. Para reflexionar; no sustituye una consulta humana en directo ni garantiza predicciones.",
        stepContext: "2 Un detalle útil", shortDetail: "Añade un detalle breve", birth: "Fecha de nacimiento (opcional — añade una capa de Camino de Vida)", chooseCards: "Elegir mis cartas →", editQuestion: "← Editar mi pregunta",
        stepCards: "3 La Brújula Intuitiva", cardsTitle: "Elige las dos cartas que más te atraigan", cardsHelp: "Primero: La energía actual. Después: Lo que la transforma.", cardsAria: "Elige exactamente dos cartas", card: "Carta", firstCard: "Elige tu primera carta.", reveal: "Ver mi lectura gratis →", changeDetail: "← Cambiar el detalle",
        loadingTitle: "Conectando tu pregunta con los símbolos", loadingHelp: "No necesitas correo electrónico. Mantén esta pestaña abierta para recibir tu señal gratuita.", loading1: "Leyendo la energía actual…", loading2: "Conectando lo que la transforma…", loading3: "Añadiendo la señal complementaria…", loading4: "Comprobando la coherencia de la lectura…",
        used: "Tu lectura utilizó", direct: "Tu señal directa", why: "Por qué apunta en esta dirección", hidden: "La influencia oculta", control: "Lo que está en tus manos", uncertain: "Lo que sigue siendo incierto",
        followupStep: "✓ Una pregunta de seguimiento gratis", followupLabel: "¿Qué te gustaría entender con más claridad?", followupButton: "Hacer mi seguimiento", followupKicker: "Tu seguimiento",
        offerKicker: "Continúa con la misma pregunta y los mismos símbolos", offerDefault: "Profundiza en la condición decisiva.", complete: "Lectura personalizada completa", packageFallback: "En profundidad", packageDetail: "1.250–1.500 palabras · caminos alternativos · riesgos · tiempos condicionales · plan de 30 días · un seguimiento escrito", checkingPrice: "Comprobando el precio…", checkoutFallback: "Obtener mi lectura en profundidad", delivery1: "Suele enviarse por correo en 20–30 minutos; puede tardar hasta 90", delivery2: "Tu pregunta exacta y tus cartas siguen juntas durante el pago", delivery3: "100 % digital · sin envío",
        privacySummary: "¿Cómo se trata mi pregunta?", privacyBody: "Tu pregunta se envía de forma segura al servicio de lectura de Deckaura para crear el resultado. La sesión gratuita se conserva hasta 30 días para que puedas pasar al pago sin volver a escribir tu pregunta. No se añade a ninguna lista de marketing. La fecha de nacimiento opcional solo se utiliza para la capa simbólica solicitada.", deleteReading: "Eliminar esta lectura",
        minQuestion: "Escribe una pregunta clara de al menos 8 caracteres.", understanding: "Comprendiendo tu pregunta…", restrictedContext: "No se recopilan más detalles para una pregunta sensible.", understood: "Pregunta comprendida. Ahora añade un detalle útil.", contextFallback: "Añade un detalle útil.", contextRequired: "Añade un detalle breve o, si quieres, tu fecha de nacimiento.", optionRequired: "Elige la opción que mejor refleje tu situación.", chooseTwo: "Elige dos cartas para la Brújula Intuitiva.", energyNow: "Energía actual", shiftsIt: "Lo que la transforma", secondCard: "Ahora elige lo que la transforma.", cardsReady: "Tus dos cartas están listas.", exactlyTwo: "Elige exactamente dos cartas.", resultReady: "Tu señal gratuita está lista.", supporting: "Señal complementaria", followupRequired: "Escribe una pregunta de seguimiento breve.", followupBusy: "Conectando la pregunta con tu lectura…", followupReady: "Tu seguimiento gratuito está listo.", verifyPackage: "Comprobando el paquete y el precio…", openCheckout: "Abriendo el pago seguro…", restored: "Tu lectura guardada se ha restaurado.", deleteConfirm: "¿Eliminar esta lectura y la pregunta guardada? Esta acción no se puede deshacer.", deleting: "Eliminando…",
        errLimit: "Tu lectura gratis se renueva cada 24 horas. Vuelve cuando esté disponible la siguiente lectura.", errProduct: "Este paquete está en pausa mientras verificamos su precio en Shopify. No se ha añadido nada al carrito.", errPaid: "No se ofrece una predicción de pago para preguntas de alto riesgo. Utiliza el siguiente paso sensato de tu respuesta gratuita.", errProgress: "Tu lectura todavía se está preparando. Espera un momento e inténtalo de nuevo.", errDefault: "No pudimos completar este paso. Tu pregunta está guardada en este navegador; inténtalo de nuevo.", upright: "derecha", reversed: "invertida"
      }
    };
    var externalTranslations = window.DeckauraPsychicTranslations || {};
    Object.keys(externalTranslations).forEach(function (key) { translations[key] = externalTranslations[key]; });
    var neutralProcessingCopy = {
      en: {
        disclosure: "A symbolic reading shaped around your question with Deckaura’s tarot, rune, astrology and numerology methods. For reflection, not live human advice or a guaranteed prediction.",
        privacyBody: "Your question is securely sent to Deckaura's reading service to create the result. The free session is stored for up to 30 days so you can continue to checkout without retyping your question. It is not added to a marketing list. Optional birth data is used only for the symbolic layer you request."
      },
      de: {
        disclosure: "Eine symbolische Deutung, abgestimmt auf deine Frage und Deckauras Tarot-, Runen-, Astrologie- und Numerologiemethoden. Zur Reflexion, nicht als menschliche Live-Beratung oder garantierte Vorhersage.",
        privacyBody: "Deine Frage wird sicher an Deckauras Deutungsdienst übermittelt, um das Ergebnis zu erstellen. Die kostenlose Sitzung wird bis zu 30 Tage gespeichert, damit du ohne erneute Eingabe zum Checkout weitergehen kannst. Sie wird keiner Marketingliste hinzugefügt. Ein optionales Geburtsdatum wird nur für die gewünschte symbolische Ebene verwendet."
      },
      es: {
        disclosure: "Una lectura simbólica adaptada a tu pregunta con los métodos de tarot, runas, astrología y numerología de Deckaura. Para reflexionar; no sustituye una consulta humana en directo ni garantiza predicciones.",
        privacyBody: "Tu pregunta se envía de forma segura al servicio de lectura de Deckaura para crear el resultado. La sesión gratuita se conserva hasta 30 días para que puedas pasar al pago sin volver a escribir tu pregunta. No se añade a ninguna lista de marketing. La fecha de nacimiento opcional solo se utiliza para la capa simbólica solicitada."
      },
      "pt-BR": {
        disclosure: "Uma leitura simbólica adaptada à sua pergunta com os métodos de tarot, runas, astrologia e numerologia da Deckaura. Serve para reflexão; não é aconselhamento humano ao vivo nem uma previsão garantida.",
        privacyBody: "Sua pergunta é enviada com segurança ao serviço de leitura da Deckaura para criar o resultado. A sessão grátis é armazenada por até 30 dias para que você siga para o checkout sem digitar a pergunta de novo. Ela não é adicionada a uma lista de marketing. A data de nascimento opcional é usada apenas na camada simbólica solicitada."
      },
      "pt-PT": {
        disclosure: "Uma leitura simbólica adaptada à sua pergunta com os métodos de tarot, runas, astrologia e numerologia da Deckaura. Serve para reflexão; não é aconselhamento humano em direto nem uma previsão garantida.",
        privacyBody: "A sua pergunta é enviada em segurança ao serviço de leitura da Deckaura para criar o resultado. A sessão gratuita é guardada até 30 dias para que possa avançar para o checkout sem voltar a escrever a pergunta. Não é adicionada a uma lista de marketing. A data de nascimento opcional é usada apenas na camada simbólica solicitada."
      },
      tr: {
        disclosure: "Sorunuza göre şekillenen; Deckaura’nın tarot, run, astroloji ve numeroloji yöntemlerini kullanan sembolik bir yorumdur. Düşünmeye yardımcı olur; canlı insan danışmanlığı veya kesin gelecek tahmini değildir.",
        privacyBody: "Sorunuz, sonucu oluşturmak için Deckaura'nın yorum hizmetine güvenli biçimde gönderilir. Ücretsiz oturum, sorunuzu yeniden yazmadan ödemeye geçebilmeniz için en fazla 30 gün saklanır. Pazarlama listesine eklenmez. İsteğe bağlı doğum tarihi yalnızca talep ettiğiniz sembolik katmanda kullanılır."
      }
    };
    Object.keys(neutralProcessingCopy).forEach(function (key) {
      translations[key] = Object.assign({}, translations[key] || {}, neutralProcessingCopy[key]);
    });
    var premiumCopy = {
      en: { premiumBadge: "Most complete", premiumFeatures: ["Full synthesis of every supplied signal", "Alternatives, risks and safeguards", "A practical 30-day plan"], premiumFeaturesAria: "Included in the In-Depth reading", checkoutNote: "One-time purchase · Secure checkout · Your saved result stays attached", purchaseAria: "Purchase assurances", purchaseTrust: ["One-time purchase", "Secure Shopify checkout", "Usually emailed in 20–30 minutes; allow up to 90"], deliverySummary: "Delivery details", deliveryBody: "Your exact question, selected cards and saved result stay together. Your personalized digital reading is written by hand from this saved result and emailed within 90 minutes. Nothing ships.", verifyPriceCta: "Check current price and availability" },
      de: { premiumBadge: "Am vollständigsten", premiumFeatures: ["Vollständige Synthese aller angegebenen Signale", "Alternativen, Risiken und Schutzmaßnahmen", "Ein praktischer 30-Tage-Plan"], premiumFeaturesAria: "In der ausführlichen Deutung enthalten", checkoutNote: "Einmaliger Kauf · Sicherer Checkout · Gespeichertes Ergebnis bleibt verbunden", purchaseAria: "Kaufsicherheit", purchaseTrust: ["Einmaliger Kauf", "Sicherer Shopify-Checkout", "Meist in 20–30 Minuten per E-Mail; bis zu 90 Minuten einplanen"], deliverySummary: "Lieferdetails", deliveryBody: "Deine genaue Frage, gewählten Karten und das gespeicherte Ergebnis bleiben verbunden. Die persönliche digitale Deutung wird aus diesem Ergebnis erstellt und innerhalb von 90 Minuten gemailt. Kein Versand.", verifyPriceCta: "Aktuellen Preis und Verfügbarkeit prüfen" },
      es: { premiumBadge: "Más completa", premiumFeatures: ["Síntesis completa de todas las señales aportadas", "Alternativas, riesgos y salvaguardas", "Un plan práctico de 30 días"], premiumFeaturesAria: "Incluido en la lectura en profundidad", checkoutNote: "Compra única · Pago seguro · Tu resultado guardado sigue vinculado", purchaseAria: "Garantías de compra", purchaseTrust: ["Compra única", "Pago seguro con Shopify", "Suele enviarse en 20–30 minutos; puede tardar hasta 90"], deliverySummary: "Detalles de entrega", deliveryBody: "Tu pregunta exacta, cartas seleccionadas y resultado guardado siguen juntos. La lectura digital personalizada se prepara a partir de este resultado y se envía en un máximo de 90 minutos. No hay envío físico.", verifyPriceCta: "Comprobar precio y disponibilidad" },
      "pt-BR": { premiumBadge: "Mais completa", premiumFeatures: ["Síntese completa de todos os sinais informados", "Alternativas, riscos e salvaguardas", "Um plano prático de 30 dias"], premiumFeaturesAria: "Incluído na leitura aprofundada", checkoutNote: "Compra única · Checkout seguro · Seu resultado salvo permanece vinculado", purchaseAria: "Garantias da compra", purchaseTrust: ["Compra única", "Checkout seguro da Shopify", "Geralmente enviado em 20–30 minutos; pode levar até 90"], deliverySummary: "Detalhes de entrega", deliveryBody: "Sua pergunta exata, cartas selecionadas e resultado salvo permanecem juntos. A leitura digital personalizada é preparada a partir deste resultado e enviada em até 90 minutos. Nada é enviado fisicamente.", verifyPriceCta: "Verificar preço e disponibilidade" },
      "pt-PT": { premiumBadge: "Mais completa", premiumFeatures: ["Síntese completa de todos os sinais indicados", "Alternativas, riscos e salvaguardas", "Um plano prático de 30 dias"], premiumFeaturesAria: "Incluído na leitura aprofundada", checkoutNote: "Compra única · Checkout seguro · O resultado guardado permanece associado", purchaseAria: "Garantias da compra", purchaseTrust: ["Compra única", "Checkout seguro da Shopify", "Habitualmente enviado em 20–30 minutos; pode demorar até 90"], deliverySummary: "Detalhes de entrega", deliveryBody: "A sua pergunta exata, cartas escolhidas e resultado guardado permanecem juntos. A leitura digital personalizada é preparada a partir deste resultado e enviada em até 90 minutos. Não existe envio físico.", verifyPriceCta: "Verificar preço e disponibilidade" },
      tr: { premiumBadge: "En kapsamlı", premiumFeatures: ["Sağlanan tüm işaretlerin tam sentezi", "Alternatifler, riskler ve koruyucu adımlar", "Pratik 30 günlük plan"], premiumFeaturesAria: "Derinlemesine yoruma dahil olanlar", checkoutNote: "Tek seferlik satın alma · Güvenli ödeme · Kayıtlı sonucunuz bağlı kalır", purchaseAria: "Satın alma güvenceleri", purchaseTrust: ["Tek seferlik satın alma", "Güvenli Shopify ödemesi", "Genellikle 20–30 dakikada e-postalanır; 90 dakikaya kadar sürebilir"], deliverySummary: "Teslimat ayrıntıları", deliveryBody: "Tam sorunuz, seçtiğiniz kartlar ve kayıtlı sonucunuz birlikte kalır. Kişiselleştirilmiş dijital yorum bu kayıtlı sonuçtan hazırlanır ve 90 dakika içinde e-postalanır. Fiziksel gönderim yoktur.", verifyPriceCta: "Güncel fiyatı ve uygunluğu kontrol et" }
    };
    var checkoutSafetyCopy = {
      en: { checkoutUncertain: "We could not verify the final cart state. Checkout is locked to prevent a duplicate. Refresh this page before trying again; the cart will be checked and cleaned before any new add.", checkoutLocked: "Checkout locked — cart status unverified" },
      de: { checkoutUncertain: "Der endgültige Warenkorbstatus konnte nicht bestätigt werden. Der Checkout bleibt gesperrt, um ein Duplikat zu verhindern. Lade die Seite neu; vor jedem neuen Hinzufügen wird der Warenkorb geprüft und bereinigt.", checkoutLocked: "Checkout gesperrt — Warenkorbstatus ungeklärt" },
      es: { checkoutUncertain: "No pudimos verificar el estado final del carrito. El pago queda bloqueado para evitar un duplicado. Recarga la página; antes de añadir de nuevo se comprobará y limpiará el carrito.", checkoutLocked: "Pago bloqueado — estado del carrito sin verificar" },
      "pt-BR": { checkoutUncertain: "Não foi possível verificar o estado final do carrinho. O checkout ficou bloqueado para evitar duplicidade. Recarregue a página; antes de uma nova inclusão, o carrinho será verificado e limpo.", checkoutLocked: "Checkout bloqueado — carrinho não verificado" },
      "pt-PT": { checkoutUncertain: "Não foi possível verificar o estado final do carrinho. O checkout ficou bloqueado para evitar duplicação. Recarregue a página; antes de uma nova adição, o carrinho será verificado e limpo.", checkoutLocked: "Checkout bloqueado — carrinho não verificado" },
      tr: { checkoutUncertain: "Sepetin son durumu doğrulanamadı. Yinelenen bir eklemeyi önlemek için ödeme kilitlendi. Sayfayı yenileyin; yeni bir eklemeden önce sepet doğrulanıp temizlenecektir.", checkoutLocked: "Ödeme kilitli — sepet durumu doğrulanamadı" },
    };
    /* The free reading can take 40+ seconds. Say so up front, and stop
       cycling the four lines after they have each been shown once. */
    var waitCopy = {
      en: { loadingEta: "It usually takes 20–60 seconds.", loadingSlow: "Still writing your reading. Thanks for waiting, it is almost ready." },
      de: { loadingEta: "Das dauert meist 20–60 Sekunden.", loadingSlow: "Deine Deutung wird noch geschrieben. Danke fürs Warten, sie ist fast fertig." },
      es: { loadingEta: "Suele tardar entre 20 y 60 segundos.", loadingSlow: "Seguimos escribiendo tu lectura. Gracias por esperar, ya casi está." },
      "pt-BR": { loadingEta: "Isso costuma levar de 20 a 60 segundos.", loadingSlow: "Ainda estamos escrevendo sua leitura. Obrigado por esperar, ela está quase pronta." },
      "pt-PT": { loadingEta: "Normalmente demora entre 20 e 60 segundos.", loadingSlow: "Ainda estamos a escrever a sua leitura. Obrigado por aguardar, está quase pronta." },
      tr: { loadingEta: "Bu genellikle 20–60 saniye sürer.", loadingSlow: "Yorumunuz hâlâ yazılıyor. Beklediğiniz için teşekkürler, neredeyse hazır." },
    };
    Object.keys(premiumCopy).forEach(function (key) {
      translations[key] = Object.assign({}, translations[key] || {}, premiumCopy[key], checkoutSafetyCopy[key] || checkoutSafetyCopy.en, waitCopy[key] || waitCopy.en);
    });
    var copy = translations[locale] || translations.en;
    var state = {
      visitorId: visitorId(),
      analyticsSessionId: analyticsSessionId(),
      topicHint: "",
      sessionId: "",
      sessionToken: "",
      question: "",
      questionSession: "",
      topic: "general",
      context: "",
      birthDate: "",
      selectedSlots: [],
      offer: null,
      packages: [],
      marketStatus: "idle",
      marketPromise: null,
      result: null,
      symbols: null,
      followupAvailable: false,
      followup: null,
      restricted: false,
      createdAt: 0,
      tracked: {},
      checkoutInFlight: false,
      checkoutOwner: null,
      checkoutLocked: false,
      checkoutSerial: 0,
    };
    var loadingTimer = null;
    var readingObserver = null;
    var REQUEST_TIMEOUT_MS = 20000;
    var API_TIMEOUTS = {
      "/api/reading/generate": 160000,
      "/api/reading/followup": 80000,
    };

    var stages = {};
    Array.prototype.forEach.call(root.querySelectorAll("[data-pc-stage]"), function (node) {
      stages[node.getAttribute("data-pc-stage")] = node;
    });

    function one(selector) { return root.querySelector(selector); }
    function all(selector) { return root.querySelectorAll(selector); }
    function setText(selector, value) {
      var node = one(selector);
      if (node) node.textContent = value;
    }
    function setStep(node, value) {
      if (!node) return;
      var badge = node.querySelector("span");
      if (!badge) { node.textContent = value; return; }
      var prefix = String(badge.textContent || "").trim();
      var label = String(value).replace(prefix, "").trim();
      while (badge.nextSibling) node.removeChild(badge.nextSibling);
      node.appendChild(document.createTextNode(" " + label));
    }
    function applyStaticCopy() {
      var trust = all(".pc__trust li");
      var topics = all("[data-topic]");
      var steps = all(".pc__step");
      var sections = all("[data-pc-reading] section");
      var premiumFeatures = all("[data-pc-premium-feature]");
      var purchaseTrust = all("[data-pc-trust]");
      one(".pc__trust").setAttribute("aria-label", copy.assurance);
      [copy.trust1, copy.trust2, copy.trust3, copy.trust4, copy.trust5].forEach(function (value, index) { if (trust[index]) trust[index].textContent = value; });
      setStep(steps[0], copy.stepQuestion);
      setText('[data-pc-stage="question"] .pc__label', copy.questionLabel);
      one("[data-pc-question]").placeholder = copy.questionPlaceholder;
      setText("#" + one("[data-pc-question]").getAttribute("aria-describedby").split(" ")[0], copy.questionHelp);
      one(".pc__topics").setAttribute("aria-label", copy.topicAria);
      Array.prototype.forEach.call(topics, function (button) { button.textContent = copy[button.getAttribute("data-topic")]; });
      setText("[data-pc-start]", copy.start);
      setText(".pc__disclosure", copy.disclosure);
      setStep(steps[1], copy.stepContext);
      setText("[data-pc-context-text-wrap] .sr-only", copy.shortDetail);
      setText("[data-pc-birth-wrap] span", copy.birth);
      setText("[data-pc-context-continue]", copy.chooseCards);
      setText("[data-pc-back-question]", copy.editQuestion);
      setStep(steps[2], copy.stepCards);
      setText('[data-pc-stage="cards"] .pc__stage-title', copy.cardsTitle);
      setText('[data-pc-stage="cards"] .pc__help', copy.cardsHelp);
      one("[data-pc-cards]").setAttribute("aria-label", copy.cardsAria);
      Array.prototype.forEach.call(all("[data-card-slot]"), function (card, index) { card.setAttribute("aria-label", copy.card + " " + (index + 1)); });
      setText("[data-pc-selection]", copy.firstCard);
      setText("[data-pc-generate]", copy.reveal);
      setText("[data-pc-back-context]", copy.changeDetail);
      setText('[data-pc-stage="loading"] .pc__stage-title', copy.loadingTitle);
      setText('[data-pc-stage="loading"] .pc__help', copy.loadingHelp + (copy.loadingEta ? " " + copy.loadingEta : ""));
      setText("[data-pc-method] > p", copy.used);
      if (sections[0]) sections[0].querySelector(".pc__kicker").textContent = copy.direct;
      [copy.why, copy.hidden, copy.control, copy.uncertain].forEach(function (value, index) { var heading = sections[index + 1] && sections[index + 1].querySelector("h2"); if (heading) heading.textContent = value; });
      setStep(steps[3], copy.followupStep);
      setText("[data-pc-followup] .pc__label", copy.followupLabel);
      setText("[data-pc-followup-send]", copy.followupButton);
      setText("[data-pc-followup-answer] .pc__kicker", copy.followupKicker);
      setText(".pc__offer-kicker", copy.offerKicker);
      setText("[data-pc-offer-title]", copy.offerDefault);
      setText("[data-pc-complete-label]", copy.complete);
      setText("[data-pc-package-name]", copy.packageFallback);
      setText("[data-pc-package-detail]", copy.packageDetail);
      setText("[data-pc-package-price]", copy.checkingPrice);
      setText("[data-pc-checkout-label]", copy.checkoutFallback);
      setText("[data-pc-premium-badge]", copy.premiumBadge);
      copy.premiumFeatures.forEach(function (value, index) { if (premiumFeatures[index]) premiumFeatures[index].textContent = value; });
      var featureList = one(".pc__premium-features");
      if (featureList) featureList.setAttribute("aria-label", copy.premiumFeaturesAria);
      setText("[data-pc-checkout-note]", copy.checkoutNote);
      copy.purchaseTrust.forEach(function (value, index) { if (purchaseTrust[index]) purchaseTrust[index].textContent = value; });
      var trustList = one(".pc__offer-trust");
      if (trustList) trustList.setAttribute("aria-label", copy.purchaseAria);
      setText("[data-pc-delivery-summary]", copy.deliverySummary);
      setText("[data-pc-delivery-body]", copy.deliveryBody);
      setText(".pc__privacy summary", copy.privacySummary);
      setText(".pc__privacy details p", copy.privacyBody);
      setText("[data-pc-delete]", copy.deleteReading);
    }
    function localizedPosition(value) {
      if (value === "Energy Now") return copy.energyNow;
      if (value === "What Shifts It") return copy.shiftsIt;
      return value;
    }
    function localizedOrientation(value) {
      if (String(value).toLowerCase() === "upright") return copy.upright;
      if (String(value).toLowerCase() === "reversed") return copy.reversed;
      return value;
    }
    function updateOffer() {
      var product = state.packages.filter(function (item) { return item && item.tier === "indepth"; })[0] || state.packages[0];
      var productReady = Boolean(state.marketStatus === "ready" && product && product.variantId === PSYCHIC_PRODUCT_REGISTRY.indepth && Number.isInteger(Number(product.priceCents)) && Number(product.priceCents) > 0 && String(product.priceLabel || "").trim());
      var canVerify = Boolean((state.marketStatus === "idle" || state.marketStatus === "error") && state.sessionId && state.sessionToken && !state.restricted);
      var checkout = one("[data-pc-checkout]");
      setText("[data-pc-package-name]", product && product.name || copy.packageFallback);
      setText("[data-pc-package-price]", productReady ? product.priceLabel : state.marketStatus === "error" ? copy.errProduct : copy.checkingPrice);
      setText("[data-pc-checkout-label]", state.checkoutLocked ? copy.checkoutLocked : productReady ? state.offer && state.offer.cta || copy.checkoutFallback : canVerify ? copy.verifyPriceCta : copy.checkingPrice);
      setText("[data-pc-button-price]", state.checkoutLocked ? "" : productReady ? " · " + product.priceLabel : "");
      if (checkout) {
        checkout.disabled = state.checkoutInFlight || Boolean(state.checkoutOwner) || state.checkoutLocked || state.restricted || (!productReady && !canVerify);
        checkout.setAttribute("aria-disabled", checkout.disabled ? "true" : "false");
      }
    }
    function hydrateMarketPackage(fallbackName) {
      if (state.marketPromise) return state.marketPromise;
      var variantId = PSYCHIC_PRODUCT_REGISTRY.indepth;
      state.marketStatus = "checking";
      updateOffer();
      state.marketPromise = Promise.all([
        fetchWithTimeout(shopRoot() + "variants/" + variantId + ".js", { credentials: "same-origin", headers: { Accept: "application/json" } }, 15000).then(parseJson),
        fetchWithTimeout(shopRoot() + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } }, 15000).then(parseJson),
      ]).then(function (responses) {
        var variant = responses[0] || {};
        var cart = responses[1] || {};
        var price = Number(variant.price);
        var currency = String(cart.currency || "").toUpperCase();
        if (String(variant.id) !== variantId || variant.available !== true || variant.requires_shipping !== false || !Number.isInteger(price) || price <= 0 || !/^[A-Z]{3}$/.test(currency)) {
          throw new Error("localized_product_contract_mismatch");
        }
        state.packages = [{
          tier: "indepth",
          variantId: variantId,
          name: String(variant.name || fallbackName || copy.packageFallback),
          priceCents: price,
          priceLabel: new Intl.NumberFormat(locale, { style: "currency", currency: currency }).format(price / 100),
          includesFollowup: true,
          recommended: true,
        }];
        state.marketStatus = "ready";
        updateOffer();
        saveState();
        return state.packages[0];
      }).catch(function (error) {
        state.packages = [];
        state.marketStatus = "error";
        updateOffer();
        throw error;
      }).finally(function () {
        state.marketPromise = null;
      });
      return state.marketPromise;
    }
    function visitorId() {
      try {
        var existing = localStorage.getItem(visitorKey);
        if (existing && /^[a-zA-Z0-9_-]{16,100}$/.test(existing)) return existing;
        var bytes = new Uint8Array(18);
        crypto.getRandomValues(bytes);
        var next = Array.prototype.map.call(bytes, function (value) { return value.toString(16).padStart(2, "0"); }).join("");
        localStorage.setItem(visitorKey, next);
        return next;
      } catch (_) {
        return "visitor_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      }
    }
    function analyticsSessionId() {
      try {
        var existing = sessionStorage.getItem(analyticsSessionKey);
        if (existing && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(existing)) return existing;
        var next = typeof crypto.randomUUID === "function"
          ? crypto.randomUUID()
          : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (value) {
              return (Number(value) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> Number(value) / 4).toString(16);
            });
        sessionStorage.setItem(analyticsSessionKey, next);
        return next;
      } catch (_) {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (value) {
          return (Number(value) ^ Math.random() * 16 >> Number(value) / 4).toString(16);
        });
      }
    }
    function announce(message) {
      var live = one("[data-pc-live]");
      if (live) live.textContent = message;
    }
    function stageFocusTarget(name, focusSelector) {
      var stage = stages[name];
      var target = focusSelector ? one(focusSelector) : null;
      if (!target && stage) target = stage.querySelector("h2, h3, legend, button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]");
      if (target && !target.matches("a[href], button, input, textarea, select, [tabindex]")) target.setAttribute("tabindex", "-1");
      return target;
    }
    function showStage(name, focusSelector) {
      Object.keys(stages).forEach(function (key) { stages[key].hidden = key !== name; });
      window.requestAnimationFrame(function () {
        var target = stageFocusTarget(name, focusSelector);
        if (target && typeof target.focus === "function") {
          try { target.focus({ preventScroll: true }); } catch (_) { target.focus(); }
        }
        if (stages[name]) stages[name].scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
    function saveState() {
      try {
        localStorage.setItem(storageKey, JSON.stringify({
          sessionId: state.sessionId,
          sessionToken: state.sessionToken,
          topic: state.topic,
          context: state.context,
          birthDate: state.birthDate,
          selectedSlots: state.selectedSlots,
          offer: state.offer,
          packages: state.packages,
          result: state.result,
          symbols: state.symbols,
          followupAvailable: state.followupAvailable,
          followup: state.followup,
          restricted: state.restricted,
          createdAt: state.createdAt || (state.createdAt = Date.now()),
        }));
      } catch (_) {}
    }
    function clearState() {
      try { localStorage.removeItem(storageKey); } catch (_) {}
    }
    function parseJson(response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        if (!response.ok || payload.ok === false) {
          var errorText = typeof payload.error === "string" ? payload.error : "";
          var error = new Error(errorText || "request_failed");
          error.code = errorText || (typeof payload.code === "string" ? payload.code : "") || "request_failed";
          error.status = response.status;
          error.safety = payload.safety === true || isSafetyCode(payload.code) || isSafetyCode(errorText) ||
            isSafetyCode(payload.error && typeof payload.error === "object" ? payload.error.code : "");
          throw error;
        }
        return payload;
      });
    }
    function fetchWithTimeout(url, options, timeoutMs) {
      var request = Object.assign({}, options || {});
      if (typeof AbortController !== "function") return fetch(url, request);
      var controller = new AbortController();
      var upstream = request.signal;
      var abortFromUpstream = function () { controller.abort(); };
      if (upstream) {
        if (upstream.aborted) controller.abort();
        else upstream.addEventListener("abort", abortFromUpstream, { once: true });
      }
      request.signal = controller.signal;
      var timer = setTimeout(function () { controller.abort(); }, timeoutMs || REQUEST_TIMEOUT_MS);
      return fetch(url, request).catch(function (error) {
        if (error && error.name === "AbortError") {
          var timeoutError = new Error("request_timeout");
          timeoutError.code = "request_timeout";
          throw timeoutError;
        }
        throw error;
      }).finally(function () {
        clearTimeout(timer);
        if (upstream) upstream.removeEventListener("abort", abortFromUpstream);
      });
    }
    function api(path, options) {
      var request = Object.assign({}, options || {});
      request.headers = Object.assign({ "Content-Type": "application/json" }, request.headers || {});
      request.credentials = "omit";
      return fetchWithTimeout(apiBase + path, request, API_TIMEOUTS[path] || REQUEST_TIMEOUT_MS).then(parseJson);
    }
    function track(name, properties) {
      var payload = properties || {};
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name, tool_name: "/pages/free-psychic-reading", reading_type: state.topic }, payload));
      } catch (_) {}
      try {
        if (typeof window.clarity === "function") window.clarity("event", name);
      } catch (_) {}
      api("/api/events", {
        method: "POST",
        keepalive: true,
        body: JSON.stringify({
          event: name,
          visitorId: state.visitorId,
          sessionId: state.sessionId || state.analyticsSessionId,
          sessionToken: state.sessionToken || undefined,
          properties: payload,
        }),
      }).catch(function () {});
    }
    function trackOnce(name, properties) {
      if (state.tracked[name]) return;
      state.tracked[name] = true;
      track(name, properties);
    }
    function setBusy(button, busy, label) {
      if (!button) return;
      if (button.hasAttribute("data-pc-checkout")) {
        var checkoutLabel = button.querySelector("[data-pc-checkout-label]");
        var checkoutPrice = button.querySelector("[data-pc-button-price]");
        state.checkoutInFlight = Boolean(busy || state.checkoutOwner || state.checkoutLocked);
        button.disabled = state.checkoutInFlight;
        button.setAttribute("aria-disabled", button.disabled ? "true" : "false");
        button.setAttribute("aria-busy", state.checkoutInFlight ? "true" : "false");
        if (state.checkoutLocked && checkoutLabel) checkoutLabel.textContent = copy.checkoutLocked;
        else if (busy && checkoutLabel) checkoutLabel.textContent = label;
        if (busy && checkoutPrice) checkoutPrice.textContent = "";
        if (!busy && !state.checkoutLocked) updateOffer();
        return;
      }
      if (!button.getAttribute("data-original-label")) button.setAttribute("data-original-label", button.textContent);
      button.disabled = busy;
      button.setAttribute("aria-busy", busy ? "true" : "false");
      button.textContent = busy ? label : button.getAttribute("data-original-label");
    }
    /* Crisis wording is classified by the shared guard (assets/deckaura-crisis-guard.js, loaded before this file by
       sections/page-free-psychic-reading.liquid): the visitor gets the localized support message, nothing is sent to the
       reading service and checkout stays closed. Without the guard nothing is screened here; the reading service's
       *_SAFETY_BLOCKED refusal (and its `restricted` flag) is the backstop and shows the same support message. */
    function isSafetyCode(code) { return /(?:^|_)safety_blocked$/i.test(String(code || "")); }
    function crisisUrgent(text) {
      var g = window.DeckauraCrisisGuard;
      if (!g || typeof g.classify !== "function" || !String(text || "").trim()) return false;
      try { return g.classify(text).kind === "urgent"; } catch (_) { return false; }
    }
    function supportCopy(kind) {
      var g = window.DeckauraCrisisGuard;
      try {
        var m = g && typeof g.message === "function" ? g.message(kind === "blocked" ? "blocked" : "urgent", locale) : "";
        if (m) return m;
      } catch (_) {}
      return copy.errDefault;
    }
    /* Support copy in an error slot is styled as guidance (psychic-funnel.css [data-pc-support]); any other text there
       keeps the error style. */
    function tagSupportNotes() {
      var notes = [supportCopy("urgent"), supportCopy("blocked")];
      Array.prototype.forEach.call(root.querySelectorAll(".pc__error"), function (node) {
        if (notes.indexOf(node.textContent || "") >= 0) node.setAttribute("data-pc-support", "");
        else node.removeAttribute("data-pc-support");
      });
    }
    if (typeof MutationObserver === "function") {
      var supportObserver = new MutationObserver(tagSupportNotes);
      Array.prototype.forEach.call(root.querySelectorAll(".pc__error"), function (node) {
        supportObserver.observe(node, { childList: true, characterData: true, subtree: true });
      });
    }
    /* Everything the visitor typed that the paid reading would use. */
    function typedCrisis() {
      var fields = ["[data-pc-question]", "[data-pc-context-text]", "[data-pc-followup-input]"];
      for (var i = 0; i < fields.length; i++) {
        var node = one(fields[i]);
        if (node && crisisUrgent(node.value)) return true;
      }
      return crisisUrgent(state.context) || crisisUrgent(state.followup && state.followup.question);
    }
    function friendlyError(error) {
      var code = error && error.code;
      if (error && (error.safety || isSafetyCode(code))) {
        state.restricted = true;
        try { updateOffer(); } catch (_) {}
        return supportCopy("blocked");
      }
      if (code === "free_reading_limit_reached") return copy.errLimit;
      if (code === "product_contract_mismatch") return copy.errProduct;
      if (code === "paid_offer_unavailable") return copy.errPaid;
      if (code === "generation_in_progress") return copy.errProgress;
      return copy.errDefault;
    }

    function startReading() {
      if (state.checkoutOwner || state.checkoutLocked) { announce(copy.checkoutLocked); return; }
      var question = String(one("[data-pc-question]").value || "").trim();
      var errorNode = one("[data-pc-question-error]");
      if (question.length < 8) {
        errorNode.textContent = copy.minQuestion;
        one("[data-pc-question]").focus();
        return;
      }
      if (crisisUrgent(question)) {
        errorNode.textContent = supportCopy("urgent");
        announce(errorNode.textContent);
        one("[data-pc-question]").focus();
        return;
      }
      errorNode.textContent = "";
      var button = one("[data-pc-start]");
      setBusy(button, true, copy.understanding);
      api("/api/reading/start", {
        method: "POST",
        body: JSON.stringify({ question: question, topicHint: state.topicHint || undefined, visitorId: state.visitorId, locale: locale, marketPath: shopRoot() }),
      }).then(function (payload) {
        state.sessionId = payload.sessionId;
        state.sessionToken = payload.sessionToken;
        /* Kept in memory only (never saved): shown on the checkout line. */
        state.question = question;
        state.questionSession = payload.sessionId;
        state.createdAt = Date.now();
        state.topic = payload.topic;
        state.offer = payload.offer;
        var fallbackProduct = Array.isArray(payload.packages) ? payload.packages[0] : null;
        state.packages = [];
        state.marketStatus = "idle";
        state.marketPromise = null;
        state.result = null;
        state.symbols = null;
        state.followupAvailable = false;
        state.followup = null;
        state.restricted = Boolean(payload.restricted);
        updateOffer();
        if (!state.restricted) hydrateMarketPackage(fallbackProduct && fallbackProduct.name).catch(function () {});
        saveState();
        configureContext(payload.context || {});
        if (state.restricted) {
          state.context = copy.restrictedContext;
          state.selectedSlots = [0, 1];
          generateReading();
          return;
        }
        announce(copy.understood);
        showStage("context", "[data-pc-context-label]");
      }).catch(function (error) {
        if (error && error.code === "free_reading_limit_reached" && showLimitWall()) { errorNode.textContent = ""; return; }
        errorNode.textContent = friendlyError(error);
      }).finally(function () { setBusy(button, false); if (state.limitReached) button.hidden = true; });
    }
    // The daily limit can answer before the reading service has classified the question, so the wall screens it too:
    // crisis wording (the shared guard's 'urgent') gets the qualified-support note, never the paid offer. A medical,
    // legal or money detail ("my boyfriend is a doctor", "my lawyer says") is an ordinary question and keeps the offer.
    var LIMIT_FOCUS = { love: "love", career: "career", decision: "decision", timing: "timing", life_path: "growth", signs: "general" };
    function isHighStakes(text) {
      return crisisUrgent(text);
    }
    function renderLimitWall() {
      var support = state.restricted || isHighStakes(one("[data-pc-question]").value);
      var text = one("[data-pc-limit-text]");
      var note = one("[data-pc-limit-support]");
      var cta = one("[data-pc-limit-cta]");
      if (note && support) {
        if (!note.hasAttribute("data-pc-default-note")) note.setAttribute("data-pc-default-note", note.textContent);
        var g = window.DeckauraCrisisGuard;
        note.textContent = g && typeof g.message === "function" ? supportCopy(state.restricted ? "blocked" : "urgent") : note.getAttribute("data-pc-default-note");
      }
      if (text) text.hidden = support;
      if (note) note.hidden = !support;
      if (cta) cta.hidden = support;
      return support;
    }
    function showLimitWall() {
      var wall = one("[data-pc-limit]");
      if (!wall) return false;
      state.limitReached = true;
      var cta = one("[data-pc-limit-cta]");
      if (cta && !cta.hasAttribute("data-pc-handoff")) {
        // The product page reads this source and pre-fills the question saved on click.
        try {
          var target = new URL(cta.getAttribute("href"), window.location.origin);
          target.searchParams.set("source", "psychic-limit");
          target.hash = "drp-intake-title";
          cta.setAttribute("href", target.pathname + target.search + target.hash);
        } catch (_) {}
        cta.setAttribute("data-pc-handoff", "");
      }
      var support = renderLimitWall();
      wall.hidden = false;
      trackOnce("psychic_limit_wall_viewed");
      announce(Array.prototype.filter.call(wall.querySelectorAll("p"), function (node) { return !node.hidden; })
        .map(function (node) { return node.textContent.trim(); }).join(" "));
      return support ? "support" : true;
    }
    function saveLimitHandoff(event) {
      var question = String(one("[data-pc-question]").value || "").trim().slice(0, 500);
      if (renderLimitWall()) { if (event) event.preventDefault(); return; }
      if (question.length < 8) return;
      try {
        sessionStorage.setItem("deckaura:reading-handoff:v1", JSON.stringify({
          source: "psychic-limit", focus: LIMIT_FOCUS[state.topicHint] || "general", tier: "indepth", question: question, createdAt: Date.now(),
        }));
      } catch (_) {}
    }

    function configureContext(config) {
      one("[data-pc-context-label]").textContent = config.label || copy.contextFallback;
      var options = one("[data-pc-context-options]");
      options.replaceChildren();
      state.context = "";
      if (config.options && config.options.length) {
        config.options.forEach(function (label) {
          var button = document.createElement("button");
          button.type = "button";
          button.textContent = label;
          button.addEventListener("click", function () {
            Array.prototype.forEach.call(options.children, function (child) { child.classList.remove("is-active"); child.setAttribute("aria-pressed", "false"); });
            button.classList.add("is-active");
            button.setAttribute("aria-pressed", "true");
            state.context = label;
            one("[data-pc-context-error]").textContent = "";
            if (!config.placeholder && !config.birthDate) continueToCards();
          });
          options.appendChild(button);
        });
      }
      var textWrap = one("[data-pc-context-text-wrap]");
      var textInput = one("[data-pc-context-text]");
      textWrap.hidden = !config.placeholder;
      textInput.placeholder = config.placeholder || "";
      textInput.value = "";
      one("[data-pc-birth-wrap]").hidden = !config.birthDate;
      one("[data-pc-birth]").value = "";
    }

    function continueToCards() {
      var textInput = one("[data-pc-context-text]");
      if (!one("[data-pc-context-text-wrap]").hidden) state.context = String(textInput.value || "").trim();
      if (crisisUrgent(state.context)) {
        state.context = "";
        one("[data-pc-context-error]").textContent = supportCopy("urgent");
        announce(one("[data-pc-context-error]").textContent);
        textInput.focus();
        return;
      }
      state.birthDate = one("[data-pc-birth-wrap]").hidden ? "" : String(one("[data-pc-birth]").value || "");
      if (!one("[data-pc-context-options]").children.length && state.context.length < 2 && !state.birthDate) {
        one("[data-pc-context-error]").textContent = copy.contextRequired;
        textInput.focus();
        return;
      }
      if (one("[data-pc-context-options]").children.length && !state.context) {
        one("[data-pc-context-error]").textContent = copy.optionRequired;
        return;
      }
      one("[data-pc-context-error]").textContent = "";
      saveState();
      announce(copy.chooseTwo);
      showStage("cards", ".pc-card");
    }

    function renderCardSelection() {
      Array.prototype.forEach.call(all("[data-card-slot]"), function (card) {
        var cardSlot = Number(card.getAttribute("data-card-slot"));
        var selectedIndex = state.selectedSlots.indexOf(cardSlot);
        card.setAttribute("aria-pressed", selectedIndex >= 0 ? "true" : "false");
        card.querySelector("[data-card-choice]").textContent = selectedIndex === 0 ? copy.energyNow : selectedIndex === 1 ? copy.shiftsIt : "";
      });
      var selection = one("[data-pc-selection]");
      selection.textContent = state.selectedSlots.length === 0 ? copy.firstCard : state.selectedSlots.length === 1 ? copy.secondCard : copy.cardsReady;
      one("[data-pc-generate]").disabled = state.selectedSlots.length !== 2;
      one("[data-pc-cards-error]").textContent = "";
    }

    function selectCard(button) {
      var slot = Number(button.getAttribute("data-card-slot"));
      var index = state.selectedSlots.indexOf(slot);
      if (index >= 0) state.selectedSlots.splice(index, 1);
      else if (state.selectedSlots.length < 2) state.selectedSlots.push(slot);
      renderCardSelection();
      if (state.selectedSlots.length === 2) trackOnce("psychic_cards_selected", { selected_count: 2 });
      saveState();
    }

    function beginLoading() {
      var copies = [copy.loading1, copy.loading2, copy.loading3, copy.loading4];
      var startedAt = Date.now();
      var node = one("[data-pc-loading-copy]");
      node.textContent = copies[0];
      if (loadingTimer) clearInterval(loadingTimer);
      loadingTimer = setInterval(function () {
        var elapsed = Date.now() - startedAt;
        var next = elapsed >= 26000 && copy.loadingSlow ? copy.loadingSlow : copies[Math.min(copies.length - 1, Math.floor(elapsed / 6500))];
        if (next && node.textContent !== next) node.textContent = next;
      }, 1000);
      showStage("loading");
    }

    function generateReading() {
      if (state.selectedSlots.length !== 2) {
        one("[data-pc-cards-error]").textContent = copy.exactlyTwo;
        return;
      }
      beginLoading();
      api("/api/reading/generate", {
        method: "POST",
        headers: { "X-Session-Token": state.sessionToken },
        body: JSON.stringify({ sessionId: state.sessionId, selectedSlots: state.selectedSlots, context: state.context, birthDate: state.birthDate || undefined }),
      }).then(function (payload) {
        state.result = payload.reading;
        state.symbols = payload.symbols;
        state.restricted = Boolean(payload.restricted);
        state.followupAvailable = payload.followupAvailable !== false && !state.restricted;
        state.followup = payload.followup && payload.followup.answer ? payload.followup : null;
        saveState();
        renderResult(payload);
        trackOnce("psychic_reading_generated", { topic: state.topic });
        announce(copy.resultReady);
        showStage("result", state.restricted ? "[data-pc-support]" : ".pc__reading");
      }).catch(function (error) {
        var wall = error && error.code === "free_reading_limit_reached" && showLimitWall();
        if (wall) { one("[data-pc-start]").hidden = true; showStage("question", wall === "support" ? "[data-pc-limit] .pc__kicker" : "[data-pc-limit-cta]"); return; }
        var message = friendlyError(error);
        announce(message);
        /* A safety refusal sends the visitor back to the question, so the message goes where they will see it. */
        if (state.restricted) {
          one("[data-pc-question-error]").textContent = message;
          one("[data-pc-cards-error]").textContent = "";
          showStage("question");
          return;
        }
        one("[data-pc-cards-error]").textContent = message;
        showStage("cards");
      }).finally(function () { if (loadingTimer) clearInterval(loadingTimer); });
    }

    function renderResult(payload) {
      Object.keys(payload.reading || {}).forEach(function (key) {
        var node = one('[data-reading="' + key + '"]');
        if (node) node.textContent = payload.reading[key];
      });
      var signals = one("[data-pc-signals]");
      signals.replaceChildren();
      if (payload.symbols && payload.symbols.cards) {
        payload.symbols.cards.forEach(function (card) {
          var row = document.createElement("div");
          row.className = "pc-signal";
          var icon = document.createElement("span"); icon.textContent = "✦";
          var copy = document.createElement("span");
          var name = document.createElement("b"); name.textContent = card.name;
          var detail = document.createElement("small"); detail.textContent = localizedPosition(card.position) + " · " + localizedOrientation(card.orientation);
          copy.append(name, detail); row.append(icon, copy); signals.appendChild(row);
        });
        var supportRow = document.createElement("div"); supportRow.className = "pc-signal";
        var supportIcon = document.createElement("span"); supportIcon.textContent = "◇";
        var supportCopy = document.createElement("span");
        var supportName = document.createElement("b"); supportName.textContent = payload.symbols.support.name;
        var supportDetail = document.createElement("small"); supportDetail.textContent = copy.supporting;
        supportCopy.append(supportName, supportDetail); supportRow.append(supportIcon, supportCopy); signals.appendChild(supportRow);
      }
      var followup = one("[data-pc-followup]");
      followup.hidden = true;
      Array.prototype.forEach.call(all("[data-pc-restricted-only]"), function (section) {
        section.hidden = !state.restricted;
        var body = section.querySelector("[data-reading]");
        if (body && !state.restricted) body.textContent = "";
      });
      var support = one("[data-pc-support]");
      if (support) support.hidden = !state.restricted;
      var openBlock = one("[data-pc-open]");
      if (openBlock) {
        openBlock.hidden = !(payload.reading && payload.reading.remainsUncertain);
        var openNote = one("[data-pc-open-note]");
        if (openNote) openNote.hidden = state.restricted;
        var openKicker = one("[data-pc-open-kicker]");
        if (openKicker) {
          if (!openKicker.hasAttribute("data-default-label")) openKicker.setAttribute("data-default-label", openKicker.textContent);
          openKicker.textContent = state.restricted ? copy.uncertain : openKicker.getAttribute("data-default-label");
        }
      }
      if (payload.followup && payload.followup.answer) {
        var restoredAnswer = one("[data-pc-followup-answer]");
        restoredAnswer.querySelector("p:last-child").textContent = payload.followup.answer;
        restoredAnswer.hidden = false;
        one("[data-pc-followup-input]").value = payload.followup.question || "";
        one("[data-pc-followup-input]").disabled = true;
        one("[data-pc-followup-send]").hidden = true;
      } else if (payload.followupAvailable === false) {
        followup.hidden = true;
      }
      var offer = one("[data-pc-offer]");
      offer.hidden = state.restricted;
      if (!state.restricted && state.offer) {
        one("[data-pc-offer-title]").textContent = state.offer.headline;
        updateOffer();
        observeOffer();
      }
      observeReading();
    }

    function sendFollowup() {
      var input = one("[data-pc-followup-input]");
      var question = String(input.value || "").trim();
      var errorNode = one("[data-pc-followup-error]");
      if (question.length < 5) { errorNode.textContent = copy.followupRequired; input.focus(); return; }
      if (crisisUrgent(question)) { errorNode.textContent = supportCopy("urgent"); announce(errorNode.textContent); input.focus(); return; }
      errorNode.textContent = "";
      var button = one("[data-pc-followup-send]");
      setBusy(button, true, copy.followupBusy);
      trackOnce("psychic_followup_started");
      api("/api/reading/followup", {
        method: "POST",
        headers: { "X-Session-Token": state.sessionToken },
        body: JSON.stringify({ sessionId: state.sessionId, followup: question }),
      }).then(function (payload) {
        var answer = one("[data-pc-followup-answer]");
        answer.querySelector("p:last-child").textContent = payload.answer;
        answer.hidden = false;
        input.disabled = true;
        button.hidden = true;
        state.followupAvailable = false;
        state.followup = { question: question, answer: payload.answer };
        saveState();
        trackOnce("psychic_followup_completed");
        announce(copy.followupReady);
      }).catch(function (error) { errorNode.textContent = friendlyError(error); })
        .finally(function () { setBusy(button, false); });
    }

    function observeOffer() {
      var offer = one("[data-pc-offer]");
      if (!offer || offer.hidden || typeof IntersectionObserver !== "function") return;
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) { trackOnce("psychic_offer_viewed"); observer.disconnect(); }
      }, { threshold: .25 });
      observer.observe(offer);
    }

    function observeReading() {
      if (readingObserver) readingObserver.disconnect();
      var reading = one("[data-pc-reading]");
      if (!reading || typeof IntersectionObserver !== "function") return;
      var halfway = reading.querySelectorAll("section")[1];
      readingObserver = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) { trackOnce("psychic_result_50_percent_read"); readingObserver.disconnect(); }
      }, { threshold: .4 });
      if (halfway) readingObserver.observe(halfway);
      var shown = Array.prototype.filter.call(reading.querySelectorAll("section"), function (section) { return !section.hidden; });
      var lastSection = shown[shown.length - 1];
      if (lastSection) {
        var complete = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting) { trackOnce("psychic_result_completed"); complete.disconnect(); }
        }, { threshold: .65 });
        complete.observe(lastSection);
      }
    }

    function shopRoot() {
      var route = "/";
      try { route = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/"; } catch (_) {}
      return route.charAt(route.length - 1) === "/" ? route : route + "/";
    }
    function cartItems(cart) { return Array.isArray(cart && cart.items) ? cart.items : []; }
    function itemVariant(item) { return String(item && (item.variant_id || item.variantId || item.id) || ""); }
    function itemSku(item) { return String(item && item.sku || "").toUpperCase(); }
    /* The signed intent carries only hidden properties, so the checkout line
       showed no question. Add the shopper's own question as a visible line
       property. The worker validates the signed hidden properties only, and
       the reading server skips psychic lines (_reading_kind), so this is
       display-only. */
    var QUESTION_LINE_LABELS = { en: "Your question", tr: "Sorunuz", es: "Tu pregunta", de: "Deine Frage", "pt-BR": "Sua pergunta", "pt-PT": "A sua pergunta" };
    function checkoutLineProperties(signed, owner) {
      var properties = Object.assign({}, signed || {});
      var question = String(state.question || "").trim();
      if (question && owner && state.questionSession === owner.sessionId) {
        properties[QUESTION_LINE_LABELS[locale] || QUESTION_LINE_LABELS[String(locale).slice(0, 2)] || QUESTION_LINE_LABELS.en] = question.slice(0, 500);
      }
      return properties;
    }
    function itemHasProperties(item, expected) {
      var properties = item && item.properties || {};
      return Object.keys(expected).every(function (key) { return String(properties[key] || "") === String(expected[key]); });
    }
    function isDeckauraReadingLine(item) {
      var properties = item && item.properties || {};
      return Object.keys(PSYCHIC_PRODUCT_REGISTRY).some(function (tier) { return PSYCHIC_PRODUCT_REGISTRY[tier] === itemVariant(item); }) ||
        /^READING-(?:DEEP|MEDIUM|PREMIUM)$/.test(itemSku(item)) ||
        /^(?:psychic|human_design)$/.test(String(properties._reading_kind || "")) ||
        Boolean(properties._psychic_session || properties._human_design_session || properties._checkout_intent ||
          properties["_Reading ID"] || properties["_Checkout Intent"] || properties["_Checkout Context"] || properties._free_token);
    }
    function readingLines(cart) { return cartItems(cart).filter(isDeckauraReadingLine); }
    function checkoutError(code) { var error = new Error(code); error.code = code; return error; }
    function errorCode(error, fallback) { return String(error && (error.code || error.message) || fallback || "checkout_failed"); }
    function wait(ms) { return new Promise(function (resolve) { window.setTimeout(resolve, Math.max(0, Number(ms) || 0)); }); }
    function readCart() {
      return fetchWithTimeout(shopRoot() + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } }, 15000).then(parseJson);
    }
    function mutateCart(path, payload) {
      return fetchWithTimeout(shopRoot() + path, {
        method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload || {}),
      }, 15000).then(parseJson);
    }

    function cleanupReadingCart(owner, targetKey) {
      var detail = { owner: owner.serial, target: targetKey ? "present" : "absent", change: "not_needed", update: "not_needed", clear: "not_needed", finalRead: "not_started" };
      function finalProof() {
        return readCart().then(function (cart) {
          detail.finalRead = "ok";
          var clean = readingLines(cart).length === 0;
          return { clean: clean, reason: clean ? "VERIFIED_CLEAN" : "READING_LINE_REMAINS", cart: cart, detail: detail };
        }, function (error) {
          detail.finalRead = errorCode(error, "CART_FINAL_READ_FAILED");
          return { clean: false, reason: detail.finalRead, detail: detail };
        });
      }
      function safeClearOrProof(cart) {
        var items = cartItems(cart);
        var lines = readingLines(cart);
        if (!lines.length) return finalProof();
        if (!(items.length && items.every(isDeckauraReadingLine))) return finalProof();
        return mutateCart("cart/clear.js", {}).then(function () {
          detail.clear = "ok";
        }, function (error) {
          detail.clear = errorCode(error, "CART_CLEAR_FAILED");
        }).then(finalProof);
      }
      function updateThenProof(cart) {
        var updates = {};
        var lines = readingLines(cart);
        lines.forEach(function (item) { if (item && item.key) updates[item.key] = 0; });
        if (!lines.length) return finalProof();
        var updatePromise = Object.keys(updates).length === lines.length
          ? mutateCart("cart/update.js", { updates: updates }).then(function () { detail.update = "ok"; }, function (error) { detail.update = errorCode(error, "CART_UPDATE_FAILED"); })
          : Promise.resolve().then(function () { detail.update = "CART_LINE_KEY_MISSING"; });
        return updatePromise.then(function () {
          return readCart().then(safeClearOrProof, function (error) {
            detail.finalRead = errorCode(error, "CART_POST_UPDATE_READ_FAILED");
            return { clean: false, reason: detail.finalRead, detail: detail };
          });
        });
      }
      var targeted = targetKey ? mutateCart("cart/change.js", { id: targetKey, quantity: 0 }).then(function () {
        detail.change = "ok";
      }, function (error) {
        detail.change = errorCode(error, "CART_CHANGE_FAILED");
      }) : Promise.resolve();
      return targeted.then(function () {
        return readCart().then(updateThenProof, function (error) {
          detail.finalRead = errorCode(error, "CART_CLEANUP_READ_FAILED");
          return { clean: false, reason: detail.finalRead, detail: detail };
        });
      });
    }

    function reconcileReadingCart(owner, targetKey, unknownAddOutcome) {
      var offsets = unknownAddOutcome ? [0, 250, 750, 1500] : [0];
      var startedAt = Date.now();
      var last = { clean: false, reason: "RECONCILIATION_NOT_STARTED" };
      return offsets.reduce(function (chain, offset) {
        return chain.then(function () {
          return wait(startedAt + offset - Date.now()).then(function () { return cleanupReadingCart(owner, targetKey); }).then(function (result) {
            last = result;
          }, function (error) {
            last = { clean: false, reason: errorCode(error, "RECONCILIATION_FAILED") };
          });
        });
      }, Promise.resolve()).then(function () { return last; });
    }

    function validCheckoutIntent(intent, owner) {
      var properties = intent && intent.properties;
      return Boolean(intent && String(intent.variantId) === owner.variantId &&
        /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(String(intent.intentId || "")) &&
        /^[0-9a-f]{64}$/i.test(String(intent.signature || "")) && properties && !Array.isArray(properties) &&
        properties._reading_kind === "psychic" && properties._psychic_session === owner.sessionId &&
        properties._checkout_intent === intent.intentId && properties._checkout_signature === intent.signature &&
        properties._package_tier === owner.tier && /^[0-9a-f]{64}$/i.test(String(properties._symbol_fingerprint || "")) &&
        String(properties._customer_locale || "").toLowerCase() === String(locale).toLowerCase() &&
        properties._funnel_version === "psychic-compass-2026-08-v1");
    }
    function ownerIsCurrent(owner) {
      return state.checkoutOwner === owner && !owner.stale && !state.restricted &&
        state.sessionId === owner.sessionId && state.sessionToken === owner.sessionToken;
    }
    function exactOwnerLine(item, owner) {
      return Boolean(item && Number(item.quantity) === 1 && itemVariant(item) === owner.variantId &&
        itemSku(item) === owner.expectedSku && itemHasProperties(item, owner.expectedProperties));
    }

    function settleOwnerFailure(owner, error, unknownAddOutcome, button) {
      if (owner.failurePromise) return owner.failurePromise;
      owner.failurePromise = reconcileReadingCart(owner, owner.targetKey, unknownAddOutcome).then(function (result) {
        var errorNode = one("[data-pc-checkout-error]");
        owner.cleanup = result;
        owner.failed = true;
        if (result.clean === true) {
          if (state.checkoutOwner === owner) state.checkoutOwner = null;
          state.checkoutLocked = false;
          state.checkoutInFlight = false;
          errorNode.textContent = friendlyError(error);
          announce(errorNode.textContent);
          setBusy(button, false);
          updateOffer();
          return { ok: false, cleanupVerified: true, code: errorCode(error) };
        }
        state.checkoutLocked = true;
        state.checkoutInFlight = true;
        errorNode.textContent = copy.checkoutUncertain;
        announce(errorNode.textContent);
        setBusy(button, true, copy.checkoutLocked);
        updateOffer();
        return { ok: false, cleanupVerified: false, code: "CART_CLEANUP_UNVERIFIED" };
      }, function () {
        state.checkoutLocked = true;
        state.checkoutInFlight = true;
        one("[data-pc-checkout-error]").textContent = copy.checkoutUncertain;
        announce(copy.checkoutUncertain);
        setBusy(button, true, copy.checkoutLocked);
        updateOffer();
        return { ok: false, cleanupVerified: false, code: "CART_CLEANUP_UNVERIFIED" };
      });
      return owner.failurePromise;
    }

    function runCheckoutOwner(owner, button) {
      owner.stage = "market";
      var product = state.packages.filter(function (item) { return item && item.tier === owner.tier; })[0];
      var productPromise = product ? Promise.resolve(product) : hydrateMarketPackage(copy.packageFallback);
      return productPromise.then(function (verifiedProduct) {
        if (!verifiedProduct || verifiedProduct.variantId !== owner.variantId || state.marketStatus !== "ready" ||
          !Number.isInteger(Number(verifiedProduct.priceCents)) || Number(verifiedProduct.priceCents) <= 0 || !String(verifiedProduct.priceLabel || "").trim()) {
          throw checkoutError("product_contract_mismatch");
        }
        if (!ownerIsCurrent(owner)) throw checkoutError("stale_checkout_owner");
        owner.stage = "intent";
        return api("/api/checkout/intent", {
          method: "POST", headers: { "X-Session-Token": owner.sessionToken },
          body: JSON.stringify({ sessionId: owner.sessionId, tier: owner.tier }),
        });
      }).then(function (intent) {
        if (!validCheckoutIntent(intent, owner)) throw checkoutError("invalid_checkout_intent");
        owner.intent = intent;
        owner.expectedProperties = Object.assign({}, intent.properties);
        if (!ownerIsCurrent(owner)) throw checkoutError("stale_checkout_owner");
        setBusy(button, true, copy.openCheckout);
        owner.stage = "preflight_cleanup";
        return cleanupReadingCart(owner, "").then(function (proof) {
          if (!proof.clean) throw checkoutError("cart_preflight_cleanup_unverified");
          if (!ownerIsCurrent(owner)) throw checkoutError("stale_checkout_owner");
          owner.stage = "adding";
          if (owner.nativeAddStarted) throw checkoutError("duplicate_native_add_blocked");
          owner.nativeAddStarted = true;
          return fetchWithTimeout(shopRoot() + "cart/add.js", {
            method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, credentials: "same-origin",
            body: JSON.stringify({ items: [{ id: Number(intent.variantId), quantity: 1, properties: checkoutLineProperties(intent.properties, owner) }] }),
          }, 15000).then(function (response) {
            owner.stage = "add_response";
            return parseJson(response);
          });
        });
      }).then(function (added) {
        var items = Array.isArray(added && added.items) ? added.items : [];
        var addedItem = items[0];
        owner.targetKey = String(addedItem && addedItem.key || "");
        if (!ownerIsCurrent(owner)) throw checkoutError("stale_add_response");
        if (items.length !== 1 || !exactOwnerLine(addedItem, owner)) throw checkoutError("cart_add_contract_mismatch");
        owner.stage = "cart_verification";
        return readCart();
      }).then(function (cart) {
        var lines = readingLines(cart);
        if (!ownerIsCurrent(owner)) throw checkoutError("stale_cart_response");
        if (lines.length !== 1 || !exactOwnerLine(lines[0], owner)) throw checkoutError("cart_verify_contract_mismatch");
        owner.targetKey = owner.targetKey || String(lines[0].key || "");
        owner.stage = "verified";
        owner.verified = true;
        trackOnce("psychic_checkout_started", { package_tier: owner.tier, variant_id: owner.variantId });
        var checkoutErrorNode = one("[data-pc-checkout-error]");
        if (!window.DeckauraCheckout || typeof window.DeckauraCheckout.open !== "function") throw checkoutError("checkout_guard_unavailable");
        var opened = window.DeckauraCheckout.open(shopRoot() + "checkout", {
          checkoutSource: "psychic_funnel", trigger: button, errorElement: checkoutErrorNode,
          loadingLabel: copy.openCheckout, errorMessage: copy.errDefault, navigationTimeoutMs: 15000,
          variantId: owner.variantId, readingType: "psychic", funnelVersion: "psychic-compass-2026-08-v1", funnelFlowId: owner.sessionId,
          onNavigationConfirmed: function () { owner.navigationConfirmed = true; },
          onNavigationError: function () { owner.navigationFailed = true; checkoutErrorNode.textContent = copy.errDefault; announce(copy.errDefault); }
        });
        if (!opened) return { ok: false, verified: true, navigationStarted: false };
        return { ok: true, verified: true };
      }).catch(function (error) {
        console.error("psychic_checkout_failed", error);
        return settleOwnerFailure(owner, error, owner.stage === "adding", button);
      });
    }

    function beginCheckout(tier, button) {
      if (state.checkoutOwner) return state.checkoutOwner.promise;
      if (state.checkoutLocked) return Promise.resolve({ ok: false, locked: true });
      var errorNode = one("[data-pc-checkout-error]");
      errorNode.textContent = "";
      if (typedCrisis()) {
        errorNode.textContent = supportCopy("urgent");
        announce(errorNode.textContent);
        return Promise.resolve({ ok: false, support: true });
      }
      if (tier !== "indepth" || !state.sessionId || !state.sessionToken || state.restricted) {
        errorNode.textContent = state.restricted ? supportCopy("blocked") : copy.errProduct;
        announce(errorNode.textContent);
        return Promise.resolve({ ok: false });
      }
      trackOnce("psychic_package_selected", { package_tier: tier });
      var owner = {
        serial: ++state.checkoutSerial, sessionId: state.sessionId, sessionToken: state.sessionToken,
        tier: tier, variantId: PSYCHIC_PRODUCT_REGISTRY.indepth, expectedSku: PSYCHIC_PRODUCT_SKU,
        expectedProperties: {}, targetKey: "", stage: "created", stale: false,
        nativeAddStarted: false, verified: false, failurePromise: null, promise: null,
      };
      state.checkoutOwner = owner;
      state.checkoutLocked = false;
      setBusy(button, true, copy.verifyPackage);
      updateOffer();
      owner.promise = Promise.resolve().then(function () { return runCheckoutOwner(owner, button); });
      return owner.promise;
    }

    function restore() {
      var saved;
      try { saved = JSON.parse(localStorage.getItem(storageKey) || "null"); } catch (_) { saved = null; }
      var savedCreatedAt = Number(saved && saved.createdAt || 0);
      if (!saved || !saved.sessionId || !saved.sessionToken || !Number.isFinite(savedCreatedAt) || savedCreatedAt <= 0 || Date.now() - savedCreatedAt > 30 * 86400000) {
        clearState();
        return false;
      }
      state.sessionId = saved.sessionId;
      state.sessionToken = saved.sessionToken;
      state.createdAt = savedCreatedAt;
      state.topic = saved.topic || "general";
      state.context = saved.context || "";
      state.birthDate = saved.birthDate || "";
      state.selectedSlots = Array.isArray(saved.selectedSlots) ? saved.selectedSlots.slice(0, 2) : [];
      state.offer = saved.offer || null;
      state.packages = [];
      state.marketStatus = "idle";
      state.marketPromise = null;
      state.result = saved.result && typeof saved.result === "object" ? saved.result : null;
      state.symbols = saved.symbols && typeof saved.symbols === "object" ? saved.symbols : null;
      state.followupAvailable = saved.followupAvailable === true;
      state.followup = saved.followup && typeof saved.followup === "object" ? saved.followup : null;
      state.restricted = Boolean(saved.restricted);
      updateOffer();
      if (state.selectedSlots.length !== 2) return false;
      trackOnce("psychic_return_visit");
      if (state.result && state.symbols) {
        renderResult({ reading: state.result, symbols: state.symbols, restricted: state.restricted, followupAvailable: state.followupAvailable, followup: state.followup });
        if (!state.restricted) hydrateMarketPackage(copy.packageFallback).catch(function () {});
        showStage("result", state.restricted ? "[data-pc-support]" : ".pc__reading");
        announce(copy.restored);
        return true;
      }
      renderCardSelection();
      showStage("cards", "[data-pc-generate]");
      announce(copy.restored);
      return true;
    }

    applyStaticCopy();
    updateOffer();

    one("[data-pc-question]").addEventListener("input", function () {
      if (!state.tracked.psychic_question_started && this.value.trim().length > 0) trackOnce("psychic_question_started");
      if (this.value.trim().length >= 8) one("[data-pc-question-error]").textContent = "";
      if (state.limitReached) renderLimitWall();
    });
    one("[data-pc-limit-cta]").addEventListener("click", saveLimitHandoff);
    Array.prototype.forEach.call(all("[data-topic]"), function (button) {
      button.setAttribute("aria-pressed", "false");
      button.addEventListener("click", function () {
        var active = button.classList.contains("is-active");
        Array.prototype.forEach.call(all("[data-topic]"), function (item) { item.classList.remove("is-active"); item.setAttribute("aria-pressed", "false"); });
        state.topicHint = active ? "" : button.getAttribute("data-topic");
        if (!active) { button.classList.add("is-active"); button.setAttribute("aria-pressed", "true"); }
      });
    });
    one("[data-pc-start]").addEventListener("click", startReading);
    one("[data-pc-context-continue]").addEventListener("click", continueToCards);
    one("[data-pc-back-question]").addEventListener("click", function () { showStage("question", "[data-pc-question]"); });
    one("[data-pc-back-context]").addEventListener("click", function () { showStage("context"); });
    Array.prototype.forEach.call(all("[data-card-slot]"), function (button) { button.addEventListener("click", function () { selectCard(button); }); });
    one("[data-pc-generate]").addEventListener("click", generateReading);
    one("[data-pc-followup-send]").addEventListener("click", sendFollowup);
    one("[data-pc-checkout]").addEventListener("click", function () { beginCheckout("indepth", this); });
    one("[data-pc-delete]").addEventListener("click", function () {
      if (state.checkoutOwner || state.checkoutLocked) { announce(copy.checkoutLocked); return; }
      if (!window.confirm(copy.deleteConfirm)) return;
      var button = this;
      setBusy(button, true, copy.deleting);
      api("/api/reading/delete", {
        method: "DELETE",
        headers: { "X-Session-Token": state.sessionToken },
        body: JSON.stringify({ sessionId: state.sessionId }),
      }).then(function () {
        clearState();
        window.location.reload();
      }).catch(function (error) {
        button.textContent = friendlyError(error);
        button.disabled = false;
      });
    });

    trackOnce("psychic_page_view");
    restore();
  });
})();
